import * as React from "react";
const SvgDoubleQuotes = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16 11.707a1 1 0 0 1 1 1v3a3 3 0 0 1-3 3 1 1 0 0 1-.102-1.995l.204-.01a1 1 0 0 0 .893-.892l.005-.103h-1a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zM22 11.707a1 1 0 0 1 1 1v3a3 3 0 0 1-3 3 1 1 0 0 1-.102-1.995l.204-.01a1 1 0 0 0 .893-.892l.005-.103h-1a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zM4 4.707a1 1 0 0 1 .103 1.995l-.206.01A1 1 0 0 0 3 7.707h1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3a3 3 0 0 1 3-3M10 4.707a1 1 0 0 1 .102 1.995l-.205.01A1 1 0 0 0 9 7.707h1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-3a3 3 0 0 1 3-3"
}));
export default SvgDoubleQuotes;
//# sourceMappingURL=DoubleQuotes.js.map